import { createSerializer } from 'nuqs';

import { filtersQuery } from '@/queries/nuqs';

const serializeTagSearch = createSerializer({
    filters: filtersQuery,
});

export type TagSearchTab = 'companies' | 'workspace';

const createTagSearchHref = (tagIds: string[], tab: TagSearchTab = 'workspace'): string => {
    const workspaceTags = Array.from(new Set(tagIds.map(String))).filter(Boolean);
    const filters =
        tab === 'companies'
            ? { workspaceTags }
            : {
                  searchDomains: {
                      workspace: { tags: workspaceTags },
                  },
              };

    return serializeTagSearch(`/search/${tab}`, { filters });
};

export { createTagSearchHref };
